
import { useEffect , useState } from "react";
import AccordionModal from "../AccordionModal/index.js";
import { loadLPTokens } from "../../utils/localStorage.js";
import { useAccount } from "wagmi";
export default function AccordionList() {
  const { address, chainId } = useAccount();
  const [lpTokens, setLPTokens] = useState([]);
  useEffect(() => {
    const tokens = loadLPTokens(chainId, address);
    setLPTokens(tokens);
  }, [address, chainId]);
  



  return (lpTokens.map((item, index) => {return(
    <AccordionModal tokenAAddress={item.tokenA} tokenBAddress={item.tokenB} pairAddress={item.pairAddress} key={index}/>
    )})
  );
}
